module.exports = __webpack_public_path__ + "img/foodSafety-print.60d93af0.png";